
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carrito",
      function () {
        return require("private-next-pages/carrito/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carrito"])
      });
    }
  